<app-top-bar [toShowProdConfig] = "isProdConfig" [toShowUnitConfig]="isUnitConfig"></app-top-bar>
<div class="row pwd_sec_center">
    <p-toast></p-toast>
    <div class="col-md-12 col-lg-12">
        <p class="heading_text">Change Password</p>
    </div>
    <hr />
    <form class="add_equipment_form" [formGroup]="changepwdForm" (ngSubmit)="onSubmit()">
        <div class="ch_pwd_sec">
            <div class="row form_field">
                <div class="col-md-4 col-lg-4"><label>Old Password
                        <!-- <span class="required_field">*</span> -->
                    </label>
                </div>
                <div class="col-md-5 col-lg-5">
                    <input type="password" formControlName="oldpassword" 
                        [ngClass]="{'borderColor' : (flag1 === true), 'nonborderColor' : (flag1 === false)}"
                        class="form-control field drill-validation">
                </div>

            </div>
            <div class="row form_field">
                <div class="col-md-4 col-lg-4"><label>New Password
                        <!-- <span class="required_field">*</span> -->
                    </label></div>
                <div class="col-md-5 col-lg-5">
                    <input type="password" formControlName="password" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}"
                        [ngClass]="{'borderColor' : (flag1 === true), 'nonborderColor' : (flag1 === false)}"
                        minlength="8" class="form-control field drill-validation">
                </div>
            </div>
            <div class="row form_field">
                <div class="col-md-4 col-lg-4 confirm_pwd">
                    <label>Confirm New Password
                        <!-- <span class="required_field">*</span> -->
                    </label>
                </div>
                <div class="col-md-5 col-lg-5">
                    <input type="password" formControlName="confirmpassword" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                        [ngClass]="{'borderColor' : (flag1 === true), 'nonborderColor' : (flag1 === false)}"
                        minlength="8" class="form-control field drill-validation">
                </div>
            </div>
            <div class="row form_field">
                <div class="col-md-4 col-lg-4"></div>
                <div class="col-md-5 col-lg-5 validation_div">
                    <p class="validation_text"> Use minimum 8 characters with a mix of letters,
                        numbers & symbols</p>
                </div>
            </div>

            <!-- <br/> -->

            <div class="row action_sec form_field">
                <div class="col-md-4 col-lg-4"></div>
                <div class="col-md-5 col-lg-5 action_sec_save_cancel">
                    <button type="submit" class="change-pwd-button commom_button">Save</button>
                    <button type="button" class="cancel-button commom_button" (click)="Navigate()" >Cancel</button>
                </div>
            </div>

        </div>
    </form>
</div>